import React from 'react';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { useAuthenticationState } from '@/hooks/use-authentication';
import { isFree } from '@/lib/role';
import { SegmentedTabs } from '@/components/segmented-tabs';
export const Route = createFileRoute('/console/_authenticated/_layout/campaigns/$publicId/_layout')({
    component: Layout,
});
function Layout() {
    const { publicId } = Route.useParams();
    const { workspace } = useAuthenticationState();
    const { t } = useTranslation();
    const tabs = React.useMemo(() => [
        {
            label: t('information'),
            path: '/console/campaigns/$publicId',
            params: { publicId },
            pathname: `/console/campaigns/${publicId}`,
        },
        {
            label: t('analytics'),
            path: '/console/campaigns/$publicId/analytics',
            params: { publicId },
            pathname: `/console/campaigns/${publicId}/analytics`,
        },
        {
            label: t('a_b_testing'),
            path: '/console/campaigns/$publicId/ab-testing',
            params: { publicId },
            pathname: `/console/campaigns/${publicId}/ab-testing`,
            disabled: isFree(workspace),
            badge: 'Solo+',
            // Has nested sub-routes (Overview / Destinations / Smart
            // Links / Smart Links by Destination) — keep the parent
            // segment highlighted while user browses within.
            exact: false,
        },
        {
            label: t('customize', { defaultValue: 'Customize' }),
            path: '/console/campaigns/$publicId/customize',
            params: { publicId },
            pathname: `/console/campaigns/${publicId}/customize`,
        },
    ], [publicId, t, workspace]);
    return (<div className="space-y-3 py-4">
            <div className="overflow-x-auto">
                <SegmentedTabs navItems={tabs}/>
            </div>
            <Outlet />
        </div>);
}
